import { initialState } from './reports-store.state';
import * as ReportsActions from './reports-store.actions';
import { createReducer, on } from '@ngrx/store';

export const ReportsReducer = createReducer(
  initialState,
  on(ReportsActions.listPaginationDailyReports, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(ReportsActions.listPaginationDailyReportsSuccess, (state, { paginationDailyReports, query, filteredDailyReportsTotalCount }) => ({
    ...state,
    paginatedDailyReports: paginationDailyReports,
    dailyReportsQuery: query,
    filteredDailyReportsTotalCount,
    isLoading: false,
  })),

  on(ReportsActions.listPaginationSummaryReports, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(ReportsActions.listPaginationSummaryReportsSuccess, (state, { paginationSummaryReports, query, filteredSummaryReportsTotalCount }) => ({
    ...state,
    paginatedSummaryReports: paginationSummaryReports,
    summaryReportsQuery: query,
    filteredSummaryReportsTotalCount,
    isLoading: false,
  })),

  on(ReportsActions.listPaginationDailyReportsFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(ReportsActions.listPaginationSummaryReportsFailure, (state) => ({
    ...state,
    isLoading: false,
  }))
);
